import React from 'react';
import clsx from 'clsx';
//Para Documentacion
import PropTypes from 'prop-types';
//MUI
import makeStyles from '@material-ui/core/styles/makeStyles';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import { Container } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
   root: {
      padding: theme.spacing(4),
      width: '100%',
      opacity: 0.9,
      margin: 'auto',
      justifyContent: 'center'
   }
}));

/**
 * Para ser usado como pie de pagina de la web de cualquier entidad con mensaje, link y anio autoactualizable.
 *
 * Cualquier otra propiedad no especificada en la documentacion sera reenviada al elemnto html `div`.
 */
function Copyright({className, mensaje, entidad, urlEntidad, ...rest}) {
   const classes = useStyles();
   return (
      <Container {...rest} className={clsx(classes.root, className)}>
         <Typography variant="subtitle1" align="center" color="textSecondary" component="p">
            {mensaje}
         </Typography>
         <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link component="a" target="_blank" href={urlEntidad}>
               {entidad}
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
         </Typography>
      </Container>
   );
}

Copyright.propTypes = {
   /**
    * Mensaje a mostrar en el Copyright
    */
   mensaje: PropTypes.string,
   /**
    * Entidad a la que pertenece el Copyright
    */
   entidad: PropTypes.string,
   /**
    * Url de la pagina principal de la entidada la que pertenece el Copyright
    */
   urlEntidad: PropTypes.string
};

Copyright.defaultProps = {
   urlEntidad: '#'
};

export default Copyright;
